define(['../appContext', '../utils/tools'],
function (app, tools) {
    "use strict";

    var r = {};

    //Test comment to see if we are on the same database...BC

    r.allStyles = new tools.Dictionary();


    r.getAllStyles = function(callback) {
        var reqData = {
            Session: app.dv.cache.session.sessionGUID,
        }

        services.call(services.endpoints.getAllStyles, reqData, function (results) {
            if (callback != null) {
                callback(results);
            }
        });
    };

    r.getStyleByUID = function (UID) {
        var sl = r.allStyles;
        for (var i = 0, il = sl.length; i < il; i++) {
            var s = sl[i];
            if (s.UID == UID) {
                return s;
            }
        }
        return null;
    };

    r.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.Style);
        entity.clientProperties.items = new tools.dictionary();
        entity.clientProperties.expressions = new tools.dictionary();
        if (entity.Definition == null
            || entity.Definition.ItemKeys == null
            || entity.Definition.ItemValues == null
            || !Array.isArray(entity.Definition.ItemKeys)
            || !Array.isArray(entity.Definition.ItemValues)) {
            return;
        }
        // only update the dictionary if we have arrays of data.
        entity.clientProperties.items.Keys = entity.Definition.ItemKeys.slice();
        entity.clientProperties.items.Values = entity.Definition.ItemValues.slice();
        entity.clientProperties.items.KeysUID = [].repeat(entity.Definition.ItemKeys.length, null);
    };

    return r;
});
